
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12 2.4a1.2 1.2 0 011.2 1.2v1.587l4.745 1.899 1.918-.96a1.2 1.2 0 111.074 2.147l-1.48.74 2.086 6.504a1.2 1.2 0 01-.343 1.26A4.787 4.787 0 0118 18a4.787 4.787 0 01-3.2-1.223 1.2 1.2 0 01-.343-1.26l2.059-6.418L13.2 7.772V19.2h2.4a1.2 1.2 0 010 2.4H8.4a1.2 1.2 0 010-2.4h2.4V7.772L7.484 9.1l2.059 6.418a1.2 1.2 0 01-.343 1.26A4.787 4.787 0 016 18a4.787 4.787 0 01-3.2-1.223 1.2 1.2 0 01-.343-1.26l2.086-6.504-1.48-.74a1.2 1.2 0 111.074-2.146l1.918.959L10.8 5.187V3.6A1.2 1.2 0 0112 2.4zm-6 9.93l-.982 3.06c.3.135.632.21.982.21s.682-.075.982-.21L6 12.33zm12 0l-.982 3.06c.3.135.632.21.982.21s.682-.075.982-.21L18 12.33z","fill":"#fff"}})])
          )
        }
      }
    